<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <!--label="批次编号"-->
            <a-form-item :label="$t('label.batchNumber')">
              <j-input :placeholder="$t('label.pleaseEnterTheBatchNumber')" v-model="queryParam.code"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <!--label="批次名称"-->
            <a-form-item :label="$t('label.batchName')">
              <j-input :placeholder="$t('label.pleaseEnterTheBatchName')" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <!--label="养户"-->
             <a-form-item :label="$t('label.grower')">
                <j-search-select-tag showSearch :placeholder="$t('label.pleaseSelectGrower')" v-model="queryParam.farmerCode" dict="efs_md_farmer,name,code"/>
             </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
               <a-form-item :label="$t('label.farms')">
                <j-dict-select-tag :placeholder="$t('label.pleaseSelectFarms')" v-model="queryParam.farmCode" dictCode="sys_depart,depart_name,org_code,org_category='5' and del_flag='0'"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('efs_md_breed_batch')">{{$t('button.export')}}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>-->
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>


        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <!--<a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>-->
              <a-menu-item v-has="'efsMdBreedBatch:sync'" v-if="record.syncStatus!='30'">
                <a-popconfirm :title="$t('tip.confrimSynchronization')" @confirm="() => handleSync(record)">
                  <a>{{ $t('button.sync') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-breed-batch-modal ref="modalForm" @ok="modalFormOk"></efs-md-breed-batch-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdBreedBatchModal from './modules/EfsMdBreedBatchModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JInput from '@/components/jeecg/JInput'
  import {postAction,postFormAction} from '@/api/manage'

  export default {
    name: 'EfsMdBreedBatchList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsMdBreedBatchModal,
      JInput
    },
    data () {
      return {
        mainTable: 'efs_md_breed_batch',
        description: 'efs_md_breed_batch管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            //title:'批次编号',
            slotName: 'tableHeader.batchNumber',
            align:"center",
            dataIndex: 'code',
            scopedSlots: { title: 'tableHeader.batchNumber'}
          },
          {
            //title:'批次名称',
            slotName: 'tableHeader.batchName',
            align:"center",
            dataIndex: 'name',
            scopedSlots: { customRender: 'name',title: 'tableHeader.batchName' }
          },
          {
              //title:'进鸡日期',
            slotName: 'tableHeader.placementDate',
            align:"center",
              dataIndex: 'actHousingDate',
              customRender:function (text) {
                  return !text?"":(text.length>10?text.substr(0,10):text)
              },
            scopedSlots: { title: 'tableHeader.placementDate'}
          },
          {
            //title:'合同编号',
            slotName: 'tableHeader.contractCode',
            align:"center",
            dataIndex: 'conCode',
            scopedSlots: { title: 'tableHeader.contractCode'}
          },
          {
            //title:'养户',
            slotName: 'tableHeader.grower',
            align:"center",
            dataIndex: 'farmerCode_dictText',
            scopedSlots: { title: 'tableHeader.grower'}
          },
            {
                //title:'养殖场',
                slotName: 'tableHeader.farms',
                align:"center",
                dataIndex: 'farmCode_dictText',
                scopedSlots: { title: 'tableHeader.farms'}
            },
          {
            //title:'饲养周期',
            slotName: 'tableHeader.feedingCycle',
            align:"center",
            dataIndex: 'batchCycle',
            scopedSlots: { title: 'tableHeader.feedingCycle'}
          },

          /*{
            title:'品类',
            align:"center",
            dataIndex: 'breedClassCode_dictText'
          },
          {
            title:'品系',
            align:"center",
            dataIndex: 'breedVarietyCode_dictText'
          },*/
          {
            //title:'计划入苗数量',
            slotName: 'tableHeader.plannedNumberOfChicks',
            align:"center",
            dataIndex: 'planHousingAmount',
            scopedSlots: { title: 'tableHeader.plannedNumberOfChicks'}
          },
            {
                //title:'同步状态',
                slotName: 'tableHeader.syncStatus',
                align:"center",
                dataIndex: 'syncStatus_dictText',
                scopedSlots: { title: 'tableHeader.syncStatus'}
            },
          /*{
            title:'实际入雏数量',
            align:"center",
            dataIndex: 'actHousingAmount'
          },*/
         /* {
            slotName: 'tableHeader.validOrNot',
            scopedSlots: { title: 'tableHeader.validOrNot'},
            align:"center",
            dataIndex: 'validFlag_dictText'
          },*/
          {
            //title: '操作',
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/batchManage/efsMdBreedBatch/list",
          delete: "/batchManage/efsMdBreedBatch/delete",
          deleteBatch: "/batchManage/efsMdBreedBatch/deleteBatch",
          exportXlsUrl: "/batchManage/efsMdBreedBatch/exportXls",
          importExcelUrl: "batchManage/efsMdBreedBatch/importExcel",
          getSyncBreedBatchInterface: "/batchManage/efsMdBreedBatch/syncBreedBatchCode",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
        handleSync(record){
            if(!this.url.getSyncBreedBatchInterface){
                this.$message.error(this.$t('tip.pleaseSet') +"url.getSyncBreedBatchInterface!")
                return
            }
            postFormAction(this.url.getSyncBreedBatchInterface, {id: record.id}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                    this.onClearSelected();
                } else {
                    this.$message.warning(res.message);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>